<template>
  <div class="mt-10 w-full">
    <div class="my-5 py-3 pl-2 text-xl lg:text-3xl font-bold w-full">
      <h1 class="w-full mx-auto uppercase">
        {{$t('teacher.classrooms')}}
      </h1>
    </div>
    <div class="mt-5 font-bold w-full flex items-center justify-between">
      <nav class="flex flex-col md:flex-row w-full justify-center md:justify-start
      items-center text-center space-y-3 md:space-y-0">
        <router-link class="text-white bg-background-academy px-10 py-1 rounded font-sans-serif
        text-lg hover:text-background-academy hover:bg-white border font-normal mr-6
        border-background-academy" to="/teacher-dashboard/media">
          {{ $t('media.media') }}
        </router-link>
        <router-link class="text-white bg-background-academy px-10 py-1 rounded font-sans-serif
        text-lg mr-6 hover:text-background-academy hover:bg-white border font-normal
        border-background-academy" to="/teacher-dashboard/templates">
          {{ $t('template.templates') }}
        </router-link>
        <router-link class="text-white bg-background-academy px-10 py-1 rounded font-sans-serif
        text-lg hover:text-background-academy hover:bg-white border font-normal
        border-background-academy mr-6" to="/teacher-dashboard/tiers">
          {{ $t('tiers.tiers') }}
        </router-link>
      </nav>
      <nav class="flex justify-end text-center">
        <router-link class="text-white bg-background-academy px-10 py-1 rounded font-sans-serif
        text-lg hover:text-background-academy hover:bg-white border font-normal flex items-center
        justify-center border-background-academy" to="/teacher-dashboard/settings">
          <settings-icon class="w-5 mr-2" />
          {{$t('teacher.settings')}}
        </router-link>
      </nav>
    </div>
    <div class="flex flex-col mt-10 space-y-8">
      <classroom-row
        v-for="classroom in classrooms"
        :key="classroom.id"
        :classroom="classroom"
        :isTeacher="true" />
    </div>
  </div>
</template>

<script>
import { getTeacherClassrooms } from '@/services/TeacherService';
import { mapGetters } from 'vuex';
import ClassroomRow from '../graphics/ClassroomRow.vue';
import SettingsIcon from '../graphics/SettingsIcon.vue';

export default {
  components: { ClassroomRow, SettingsIcon },

  data() {
    return {
      classrooms: [],
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  created() {
    this.getClassrooms();
  },

  methods: {
    getClassrooms() {
      getTeacherClassrooms(this.user.teacher.id).then(({ data }) => {
        this.classrooms = [];
        this.classrooms = data;
      });
    },

  },
};
</script>
